export const fmt = (num) => {
  const abs = Math.abs(num).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return num < 0 ? `-${abs}` : abs;
};

export const strip = (val) => {
  const cleaned = val.replace(/\s/g, '').replace(',', '.');
  const negative = cleaned.startsWith('-');
  return (negative ? '-' : '') + cleaned.replace(/[^0-9.]/g, '');
};
